const semanticClassNames = {
  root: 'slideshowIndicator',
  input: 'slideshowIndicator__input',
} as const;

export default semanticClassNames;
